// File: /opt/dev_environment/assets/workspace/app-init/src/components/DirectionSelector/DirectionSelector.js

import React from 'react';
import { QUERY_DIRECTIONS } from '../../constants/leitner';
import './DirectionSelector.css';

function DirectionSelector({ value, onChange }) {
  return (
    <div className="direction-selector" role="radiogroup" aria-label="Abfragerichtung">
      {Object.entries(QUERY_DIRECTIONS).map(([key, label]) => (
        <button
          key={key}
          className={`direction-selector__option ${value === label ? 'direction-selector__option--active' : ''}`}
          role="radio"
          aria-checked={value === label}
          onClick={() => onChange(label)}
          type="button"
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default DirectionSelector;